import { Descriptions, notification, Popover, Skeleton } from 'antd';
import React, { useState } from 'react';
import { getFacilityDetails } from '../../../Apis/Facility';
import HeartIcon from '../../../Assets/Icons/HeartIcon';
import { message } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';
import OpenNewArrowIcon from '../../../Assets/Icons/OpenNewArrowIcon';
import {
  DisconnectButton,
  FacilityDetailsButton,
  FacilityDetailsModal,
  PccSigninButton,
  StyledAlert,
  StyledFacilityStatusCard,
  StyledFacilityStatusCardContent,
  StyledFacilityStatusCardHeader,
  StyledFacilityStatusCardHeaderFacilityIcon,
  StyledFacilityStatusCardHeaderFacilityName,
  StyledFacilityStatusCardHeaderItem
} from './styledComponent';
import { removeEmrAuthApi } from '../../../Apis/User';

const FacilityStatusCard = ({
  clinicFacilityStatus,
  userNotificationDashboard
}) => {
  const [isFacilityDetailsModalOpen, SetIsFacilityDetailsModalOpen] =
    useState(false);
  const [facilityDetailsModalData, setFacilityDetailsModalData] =
    useState(null);
  const handleDisconnect = async () => {
    const facilityId = clinicFacilityStatus?.facilityId; // ✅ Get from props
    if (!facilityId) {
      notification.error({
        message: 'Facility ID Missing',
        description: 'Facility ID not found. Please check and try again.'
      });
      return;
    }

    try {
      const response = await removeEmrAuthApi(facilityId);
      if (response.data.success) {
        userNotificationDashboard();
        notification.success({
          message: 'Disconnected Successfully',
          description: 'EMR connection has been successfully removed.'
        });
      } else {
        notification.warning({
          message: 'Disconnection Failed',
          description: 'Unable to disconnect EMR. Please try again later.'
        });
      }
    } catch (error) {
      console.error('❌ Error disconnecting EMR:', error);
      notification.error({
        message: 'Error Disconnecting',
        description: 'Something went wrong while disconnecting EMR.'
      });
    }
  };
  const facilityDetails = facilityId => {
    setFacilityDetailsModalData(null);
    SetIsFacilityDetailsModalOpen(true);
    getFacilityDetails(facilityId)
      .then(response => {
        if (response.data.success) {
          console.log('facility ', response.data.result);
          setFacilityDetailsModalData(response.data.result[0]);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      <StyledFacilityStatusCard>
        <StyledFacilityStatusCardHeader>
          <StyledFacilityStatusCardHeaderItem>
            <StyledFacilityStatusCardHeaderFacilityIcon>
              <HeartIcon />
            </StyledFacilityStatusCardHeaderFacilityIcon>
            <Popover title={clinicFacilityStatus.facilityName} placement='top'>
              <StyledFacilityStatusCardHeaderFacilityName>
                {clinicFacilityStatus.facilityName}
              </StyledFacilityStatusCardHeaderFacilityName>
            </Popover>
          </StyledFacilityStatusCardHeaderItem>
          <StyledFacilityStatusCardHeaderItem>
            <StyledFacilityStatusCardHeaderFacilityIcon>
              <FacilityDetailsButton
                onClick={() => facilityDetails(clinicFacilityStatus.facilityId)}
              >
                <OpenNewArrowIcon />
              </FacilityDetailsButton>
            </StyledFacilityStatusCardHeaderFacilityIcon>
          </StyledFacilityStatusCardHeaderItem>
        </StyledFacilityStatusCardHeader>
        <StyledFacilityStatusCardContent>
          {clinicFacilityStatus?.emrHandlingData?.emrVerificationStatus ===
          'NOT_VERIFIED' ? (
            <StyledAlert
              description={`Please verify EMR to continue using the app.`}
              type='error'
              showIcon
              action={
                <a
                  href={clinicFacilityStatus.emrHandlingData.emrVerificationUrl}
                  target={'_self'}
                >
                  <PccSigninButton />
                </a>
              }
            />
          ) : (
            <StyledAlert
              description={`Please Disconnect EMR .`}
              type='error'
              showIcon
              action={
                <DisconnectButton onClick={handleDisconnect}>
                  <DisconnectOutlined />
                  Disconnect
                </DisconnectButton>
              }
            />
          )}
        </StyledFacilityStatusCardContent>
      </StyledFacilityStatusCard>
      <FacilityDetailsModal
        title={'Facility Details'}
        open={isFacilityDetailsModalOpen}
        closable={true}
        footer={null}
        onCancel={() => {
          SetIsFacilityDetailsModalOpen(false);
        }}
        width={'80%'}
      >
        <div>
          {
            <div>
              <Descriptions bordered>
                <Descriptions.Item label='Name' span={2}>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.facilityName
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '80px' }}
                    />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Id'>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.ehrConfiguration.facilityId
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '20px' }}
                    />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Org Id' span={3}>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.ehrConfiguration.organisationId
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '20px' }}
                    />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Note Type' span={3}>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.ehrConfiguration.noteType
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '65px' }}
                    />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Transcription Flow' span={2}>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.ehrConfiguration.transcriptionFlow
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '100px' }}
                    />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Reviewer Count'>
                  {facilityDetailsModalData ? (
                    facilityDetailsModalData?.ehrConfiguration.reviewerCount
                  ) : (
                    <Skeleton
                      active
                      title={false}
                      paragraph={{ rows: 1, width: '20px' }}
                    />
                  )}
                </Descriptions.Item>
              </Descriptions>
            </div>
          }
        </div>
      </FacilityDetailsModal>
    </>
  );
};

export default FacilityStatusCard;
